import { getEnvironment } from './utility';

const environment = getEnvironment();
const isDevelopment = environment === 'development';

const mainDomain = isDevelopment ? 'localhost' : '.cmn.org';
const wordpressSiteEnvironments = {
    development: 'https://staging.cmn.org/',
    staging: 'https://staging.cmn.org/',
    test: 'https://staging.cmn.org/',
    production: 'https://fundraisers.cmn.org/'
};

const wordpressApiEndPoint = wordpressSiteEnvironments[getEnvironment() as keyof typeof wordpressSiteEnvironments];

/**
 * All the constants for the site.
 */
export const globalDef = {
    mainDomain,
    wordpressApiEndPoint,
};
